import dynamic from 'next/dynamic';

import LazyHydration from 'components/LazyHydration';

const BlogArticles = dynamic(() => import('./BlogArticles'));

const MIN_ARTICLES_LENGTH = 3;

const DynamicallyLoadedBlogArticles = ({ articles, ...rest }) =>
  articles.length < MIN_ARTICLES_LENGTH ? null : (
    <LazyHydration placeholderSize={{ height: 424 }}>
      <BlogArticles articles={articles} {...rest} />
    </LazyHydration>
  );

export default DynamicallyLoadedBlogArticles;
